/** Visible también en móvil, fuera del historial que se desplaza. */
export function DemoChatNotice() {
  return <aside aria-label="Aviso del chat de demostración" style={{ flexShrink: 0, padding: '12px 16px', background: 'var(--aten-suave)', color: 'var(--aten-texto)', borderBottom: '1px solid var(--aten-borde)', fontSize: 14, lineHeight: 1.45 }}>
    <strong>Estás viendo una simulación de Alexia</strong>
    <p style={{ margin: '4px 0 0' }}>Este chat solo muestra respuestas de ejemplo. En la demo, Alexia no interpreta tus mensajes ni procesa solicitudes reales. Usa los ejemplos para ver cómo funciona.</p>
  </aside>;
}
